import { t as e } from "../../utils-C1uyTI6x.js";
import { t } from "../../constants-B7fXbm2f.js";
import { t as n } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as r, createElementVNode as i, normalizeClass as a, openBlock as o } from "vue";
//#region ../src/icons/monitor-off.vue
var s = {
	name: "DtIconMonitorOff",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (e) => Object.keys(t).includes(e)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return t[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded"), this.uniqueID = e();
	}
}, c = [
	"aria-label",
	"data-qa",
	"aria-hidden"
], l = ["clip-path"], u = ["id"];
function d(e, t, n, s, d, f) {
	return o(), r("svg", {
		"aria-label": n.ariaLabel,
		class: a([f.iconSizeClass, "d-icon d-icon--monitor-off"]),
		"data-qa": f.dataQA,
		"aria-hidden": f.ariaHidden,
		role: "img",
		"data-name": "Monitor Off",
		viewBox: "0 0 12 12",
		xmlns: "http://www.w3.org/2000/svg"
	}, [i("g", {
		"clip-path": `url(#${e.uniqueID}a)`,
		"fill-rule": "evenodd",
		"clip-rule": "evenodd",
		fill: "currentColor"
	}, [...t[0] || (t[0] = [i("path", { d: "M4 1.5a.5.5 0 0 1 .5-.5H10a1.5 1.5 0 0 1 1.5 1.5v5a.5.5 0 0 1-1 0v-5A.5.5 0 0 0 10 2H4.5a.5.5 0 0 1-.5-.5Zm-3.5 1v5A1.5 1.5 0 0 0 2 9h3.5v1H4a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1H6.5V9h1.793l2.353 2.354a.5.5 0 0 0 .708-.708l-10-10a.5.5 0 1 0-.708.708l.145.144A1.741 1.741 0 0 0 .5 2.5Zm1.146 5.354A.5.5 0 0 0 2 8h5.293L1.534 2.241A.92.92 0 0 0 1.5 2.5v5a.5.5 0 0 0 .146.354Z" }, null, -1)])], 8, l), i("defs", null, [i("clipPath", { id: `${e.uniqueID}a` }, [...t[1] || (t[1] = [i("path", {
		fill: "#fff",
		d: "M0 0h12v12H0z"
	}, null, -1)])], 8, u)])], 10, c);
}
var f = /* @__PURE__ */ n(s, [["render", d]]);
//#endregion
export { f as default };

//# sourceMappingURL=monitor-off.js.map